import React, {Component} from 'react';
import CreateRoleModal from './modals/CreateRoleModal';
import BackEnd from '../../../backend/BackEnd';
import PermissionsRow from "./components/PermissionsRow";
import {userContext} from "../../../auth/Auth";
import ConfirmationModal from "../../../modals/ConfirmationModal";

class Permissions extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        isLoading: true,
        showCreateRoleModal: false,
        showConfirmationModal: false,
        permissionGroupId: null,
        permissionGroups: [],
        roles: [],
        permissions: []
    };
    getGroupsEndpoint = new BackEnd.Permissions.GetGroups();
    setRolePermissions = new BackEnd.Permissions.SetRolePermissions();
    getRolesEndpoint = new BackEnd.Roles.GetAll();

    async componentWillMount() {
        let permissionGroups = await this.getGroupsEndpoint.call();
        let roles = await this.getRolesEndpoint.call();

        this.setState({
            isLoading: false,
            permissionGroupId: permissionGroups[0].id,
            permissionGroups: permissionGroups,
            roles: roles,
            permissions: permissionGroups[0].permissions
        });
    }

    render() {
        let loadingSpinner = <div className="text-center m-y-2">
            <i className="fa fa-circle-o-notch fa-spin fa-4x text-primary"/>
        </div>;

        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <h1>
                                <span className="text-muted font-weight-light">
                                    <i className="page-header-icon ion-gear-a"/> Система /
                                </span> Права доступа
                            </h1>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12">
                        <div className="panel">
                            <div className="panel-body">
                                {
                                    this.state.isLoading
                                        ? loadingSpinner
                                        : <div>
                                            <div className="form-inline">
                                                <div className="form-group">
                                                    <label htmlFor="permission-group" className="m-r-1">
                                                        Группа прав доступа
                                                    </label>
                                                    <select className="form-control" name="permission-group" id="permission-group"
                                                            value={this.state.permissionGroupId}
                                                            onChange={event => this.updatePermissionGroup(event.target.value)}>
                                                        {this.state.permissionGroups.map(pg =>
                                                            <option key={pg.id} value={pg.id}>{pg.name}</option>
                                                        )}
                                                    </select>
                                                </div>
                                            </div>
                                            <table className="table m-b-0">
                                                <thead>
                                                <tr>
                                                    <th className="p-a-2"/>
                                                    {this.state.permissions.map(permission =>
                                                        <th key={permission.id} className="p-a-2">{permission.text}</th>)}
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.state.roles.map(role =>
                                                    <PermissionsRow key={role.id}
                                                                    role={role} permissions={this.state.permissions}
                                                                    onChange={rolePermissions => this.updateRolePermissions(role, rolePermissions)}/>
                                                )}
                                                </tbody>
                                                <tfoot>
                                                <tr>
                                                    <td colSpan={this.state.permissions.length + 1}>
                                                        <button className="btn btn-primary btn-xs"
                                                                onClick={() => this.setState({showCreateRoleModal: true})}>
                                                            Создать роль
                                                        </button>
                                                    </td>
                                                </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <CreateRoleModal show={this.state.showCreateRoleModal}
                                 onSave={() => this.refreshRoles()}
                                 onHide={() => this.setState({showCreateRoleModal: false})}/>
                <ConfirmationModal show={this.state.showConfirmationModal}
                                   onHide={() => this.setState({showConfirmationModal: false})}
                                   onConfirm={() => window.location.reload()}>
                    Вы изменили настройки прав для своей роли. Для того,
                    {' '}
                    чтобы новые настройки отразились в интерфейсе системы необходимо перезагрузить страницу. Продолжить?
                </ConfirmationModal>
            </div>
        );
    }

    updatePermissionGroup(permissionGroupId) {
        permissionGroupId = parseInt(permissionGroupId);

        this.setState({
            permissionGroupId,
            permissions: this.state.permissionGroups
                .find(pg => pg.id === permissionGroupId)
                .permissions
        });
    }

    async updateRolePermissions(role, rolePermissions) {
        let {roles} = this.state;
        let permissions = Object.keys(rolePermissions)
            .map(k => ({id: k, flag: rolePermissions[k]}))
            .filter(({flag}) => flag)
            .map(({id}) => id);

        roles[roles.indexOf(role)].permissions = rolePermissions;

        this.setState({roles});

        let result = await this.setRolePermissions.call({
            roleId: role.id,
            permissions
        });

        if (result.success) {
            if (userContext.get().roleId === role.id)
                this.setState({showConfirmationModal: true});
        }
    }

    async refreshRoles() {
        let roles = await this.getRolesEndpoint.call();

        this.setState({roles});
    }
}

export default Permissions;


// WEBPACK FOOTER //
// ./src/pages/System/Permissions/Permissions.js